import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_report_restrictions_grid___ds_view_report_restrictions_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { entities: { entity: string, entity_id: number }[], $top?: number, $skip?: number }): Promise<{ result?: { entity?: string, entity_id?: number, label?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.entities)) {
      $missingRequiredInParams.push('\'entities\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { entities?: { entity: string, entity_id: number }[], $keys: { entity?: string, entity_id?: number }[] }): Promise<{ result?: { entity?: string, entity_id?: number, label?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      entities: { entity: string, entity_id: number }[]    }) {
        if(isNil($inParams.entities)) {
          return true; 
        }
      return false;
    }
}
